<template>
  <div class="container">
    <Loader v-if="!loaded" :isLoading="true"></Loader>
    <template v-else>
      <div class="main-container-header">
        <div class="main-container-header__title">
          <h2>Manage Airlines</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div id="agents-panel">
            <div id="agents-panel-inner">
              <div class="panel panel-primary">
                <div class="panel-body">
                  <div class="alert alert-success" v-if="success">
                    Airline activation settings has been updated
                  </div>

                  <div :class="{'form-group': idx !== keys.length - 1}" v-for="(id, idx) in keys" :key="idx">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" :disabled="!isSuperagency()" v-model="airlines[id].value"> {{ airlines[id].name }}
                      </label>
                    </div>
                  </div>
                  <div class="form-group" v-if="isSuperagency()">
                    <span class="btn btn-primary" @click="save()">Save</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>


  </div>
</template>

<script>
import axios from "@/services/axios";
import NavigationBar from "./shared/+navigation-bar";
import helpers from "@/mixins/helpers";
import Loader from './shared/+loader'

export default {
  components: {
    NavigationBar,
    Loader,
  },
  data() {
    return {
      loaded: false,
      keys: [],
      airlines: {},
      success: false
    };
  },
  mounted: function() {
    this.init();
  },
  computed: {
  },
  mixins: [helpers],
  methods: {
    init() {
      if (this.can('front.airlines')) {
        axios.get("/agent/account/airlines")
            .then(res => {
              this.airlines = res.data;
              this.keys = this.transformObject(res.data);
              this.loaded = true
            });
      }
    },
    transformObject(item) {
      let keys = Object.keys(item);
      return keys.sort((a, b) => this.airlines[a].name > this.airlines[b].name ? 1 : -1)
    },
    save() {
      this.success = false;
      axios.post("/agent/account/airlines", this.airlines)
          .then(res => {
            this.success = true;
          });
    }
  }
};
</script>

<style lang="scss">
#agents-panel {

  .table {
    border: 1px solid #ececec;

    tbody {
      tr {
        &:hover {
          background-color: #f7fbff;
        }
      }
    }
    thead {
      tr {
        background-color: #ececec;
      }
      th {
        color: #606060;
        text-transform: uppercase;
        font-weight: 600;
      }
    }

    td {
      border-bottom: 0;
      border-bottom: 1px solid #ececec;
      vertical-align: middle;

      .superAction {
        margin-left: .5rem;
        font-weight: 400;
        font-size: 12px;
        cursor: pointer;
      }

      button {
        font-size: 12px;
      }
    }

    .linkButton {
      display: inline-flex;
      background-color: transparent;
      font-weight: 700;
      padding: 0.25rem 0;
      border: none;

      &:hover {
        color: #c00005;
        text-decoration: underline;
      }

      &.linkGray {
        color: #606060;
      }
    }
  }

  .agentStatus {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 800;
    letter-spacing: 0.05rem;

    &.active {
      color: #00A538;
    }

    &.inactive {
      color: #4A7B8A;
    }

    &.invited {
      color: #FFA800;
    }
  }

  tr.disabled {
    color: #888;
    .linkButton {
      display: none;
    }
  }
}

#app {
  .main-container-header {
    padding: 2rem 0 1rem;
    justify-content: space-between;
    &__title {
      display: flex;
      width: 100%;
    }

    &__action {
      display: flex;
      button {
        margin-left: 1rem;
      }
    }
  }
}
</style>
